import { Button } from "@miror-ui/components";
import { Avatar } from "shared/components/atoms/Avatar";
import FilledPhoneIcon from "shared/assets/icons/FilledPhone.svg";
import { css } from "twin.macro";
import { CalledFortuneTeller } from "shared/types";
import { useCallInfo } from "features/Now/hooks/useCallInfo";
import { TextSkeleton } from "shared/components/atoms/TextSkeleton";

const shadowCss = css({ boxShadow: "0 0 8px 0 rgba(200, 200, 200, 0.5)" });

interface Props {
  fortuneTeller: CalledFortuneTeller;
  className?: string;
}

export const RecentOrderCard = ({ fortuneTeller, className }: Props) => {
  const callInfo = useCallInfo();

  const lastCalledDate = callInfo.getLastCalledDate(fortuneTeller);
  const lastCalledDay = callInfo.getLastCalledDay(fortuneTeller);
  const lastCalledHour = callInfo.getLastCalledHour(fortuneTeller);
  const lastCalledMinute = callInfo.getLastCalledMinute(fortuneTeller);
  const buttonLabel = callInfo.getButtonLabel(fortuneTeller);
  const buttonStyle = callInfo.getButtonStyle(fortuneTeller);

  return (
    <section tw="rounded-xl p-4" css={shadowCss} className={className}>
      <div tw="grid grid-flow-col justify-between">
        <div tw="font-bold leading-none text-black">
          <h3 tw="text-[19px] leading-7">
            <span tw="inline-block w-[7px] h-[7px] bg-gradient-theme-to-l rounded-full mb-0.5 mr-2" />
            前回の相談
          </h3>

          <p tw="text-sm leading-4 mt-3 line-clamp-1">
            {fortuneTeller ? (
              fortuneTeller?.name
            ) : (
              <TextSkeleton lineCount={1} />
            )}
          </p>

          <>
            {fortuneTeller ? (
              <div tw="font-semibold text-2xs text-secondary mt-1.5">
                <time>
                  {lastCalledDate}({lastCalledDay})
                </time>
                <span>・</span>
                <span>
                  {lastCalledHour}
                  {lastCalledMinute}
                </span>
              </div>
            ) : (
              <TextSkeleton lineCount={1} tw="mt-1.5" />
            )}
          </>
        </div>

        <Avatar src={fortuneTeller?.imageUrl} size={58} />
      </div>

      <div tw="grid grid-flow-col justify-between mt-3">
        <div>
          <ul tw="relative h-5">
            {fortuneTeller?.telFortuneReviews.map((review, index) => (
              <li key={review.id}>
                <Avatar
                  src={review.user.imageUrl}
                  size={19.64}
                  tw="absolute left-0 z-30 border-2 border-solid border-white rounded-full"
                  css={{ left: 12 * index, zIndex: 30 - index }}
                  blur={1}
                />
              </li>
            ))}
          </ul>
          <p tw="font-semibold text-[9px] text-secondary mt-1.5">
            {fortuneTeller?.reviewCount || 0}人が高評価
          </p>
        </div>
        <Button
          tw="h-12 px-4 text-[13px] pt-0.5"
          css={buttonStyle}
          onClick={() => callInfo.onClick(fortuneTeller)}
          disabled={!fortuneTeller?.telAcceptFlag}
        >
          <FilledPhoneIcon tw="svg mr-1.5" />
          {buttonLabel}
        </Button>
      </div>
    </section>
  );
};
